module.exports = __webpack_public_path__ + "media/images/regions/thumbnails/latin_america_and_caribbean-928762ad764986109b670613df67b917.png";